import React from 'react';
import styled, { keyframes } from 'styled-components';

import { putaoWS } from '../../lib/ws';

import { Mask, Flex } from '../../lib/components/LessonPath/static/style';
import utils from '../../lib/utils';

export default class ClearHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showConfirmDialog: true,
            showClearLoading: false,
        }
    }

    clickCancleHandler = () => {
        const { cancleHandler } = this.props;

        if (cancleHandler && typeof cancleHandler === 'function') {
            cancleHandler();
        }
    }

    clickClearHandler = () => {
        const { cancleHandler } = this.props;

        this.setState({
            showClearLoading: true,
            showConfirmDialog: false
        });

        putaoWS.deleteAllVideo(content => {
            this.setState({
                showClearLoading: false
            });

            if (content && content.size !== undefined && content.size !== null) {
                utils.showTips(`已清理 ${(content.size / 1024 / 1024).toFixed(2)} M缓存数据`, 2000)
            }

            if (cancleHandler && typeof cancleHandler === 'function') {
                cancleHandler();
            }
        });
    }

    render() {
        const { showConfirmDialog, showClearLoading } = this.state;
        return (
            <Mask opacity={0.6}>
                {showConfirmDialog &&
                    <ConfirmDialog>
                        <Title>提示</Title>
                        <Text>缓存学习内容和视频将被删除，学习时将会重新下载</Text>
                        <Bottom>
                            <Button
                                type='left'
                                onClick={this.clickCancleHandler}
                            >
                                取消
                        </Button>
                            <Button
                                onClick={this.clickClearHandler}
                            >
                                清理
                        </Button>
                        </Bottom>
                    </ConfirmDialog>
                }
                {showClearLoading &&
                    <ClearLoading>
                        <ClearAnimate />
                        <div>清理中...</div>
                    </ClearLoading>
                }
            </Mask>
        );
    }
}

const ClearAnimation = keyframes`
    0% {
        transform: rotateZ(0deg);
        -webkit-transform: rotateZ(-deg);
    }
    25% {
        transform: rotateZ(30deg);
        -webkit-transform: rotateZ(30deg);
    }
    50% {
        transform: rotateZ(0deg);
        -webkit-transform: rotateZ(0deg);
    }
    75% {
        transform: rotateZ(-30deg);
        -webkit-transform: rotateZ(-30deg);
    }
    100% {
        transform: rotateZ(0deg);
        -webkit-transform: rotateZ(0deg);
    }
`;

const CenterBox = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    box-sizing: border-box;
`;

const ConfirmDialog = styled(CenterBox)`
    padding: 0.3rem;
    width: 6rem;
    height: 3.5rem;
    background: #fff;
    border-radius: 0.5rem 0.3rem;
`;

const Title = styled.div`
    font-size: 0.36rem;
    margin-bottom: 0.4rem;
`;

const Text = styled.div`
    font-size: 0.28rem;
    color: #333;
`;

const Bottom = styled(Flex)`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.8rem;
    line-height: 0.8rem;
    text-align: center;
    border-top: 1px solid #f5f5f5;
    font-size: 0.28rem;
`;

const Button = styled.div`
    width: 50%;
    ${props => props.type && props.type === 'left' ? `
        left: 0;
        color: #999;
        border-right: 1px solid #f5f5f5;
    ` : `
        right: 0;
        color: #0262DA
    `}
`;

const ClearLoading = styled(CenterBox)`
    width: 2rem;
    height: 2rem;
    background: #fff;
    border-radius: 0.2rem;

    >div {
        position: absolute;
        bottom: 0.2rem;
        left: 0;
        width: 100%;
        text-align: center;
    }
`;

const ClearAnimate = styled.div`
    position: absolute;
    top: 0.6rem;
    width: 0.5rem;
    height: 0.5rem;
    background: url(${require('../../static/img/set_img/clear_history.png')}) no-repeat center;
    background-size: contain;
    animation: ${ClearAnimation} 0.75s infinite;
`;


// WEBPACK FOOTER //
// ./src/components/dialog/ClearHistory.js